import type { HeadersFunction, MetaFunction } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { useHydrateAppliedSearchCriteria } from '~/features/search/criteria'
import { useHydrateArea, useHydrateSelectedArea } from '~/features/top/area'
import { topLoader } from '~/features/top/loader.server'
import { useHydrateSelectedPoplarRestaurantsArea } from '~/features/top/pc/restaurants'
import { PcTopRoot } from '~/features/top/pc/root'
import { SDTopRoot } from '~/features/top/sd/root'
import { normalizedShouldRevalidate } from '~/lib/remix'
import { useIsPC } from '~/lib/ua'

// トップはパーソナライズされたデータを SSR するためキャッシュしない (Bot からのアクセスは除く)
// @see: https://ikyu.atlassian.net/wiki/x/DACBmgE
export const loader = topLoader

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return loaderHeaders
}

export const shouldRevalidate = normalizedShouldRevalidate

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  if (data === undefined) {
    throw new Response('Not Found', { status: 404 })
  }
  return data.meta
}

export type TopRootProps = { data: ReturnType<typeof useLoaderData<typeof loader>> }

export default function Top() {
  const isPc = useIsPC()
  const data = useLoaderData<typeof loader>()
  useInit(data)
  return isPc ? <PcTopRoot data={data} /> : <SDTopRoot data={data} />
}

export function useInit(data: ReturnType<typeof useLoaderData<typeof loader>>) {
  useHydrateAppliedSearchCriteria(data.criteria)
  useHydrateArea(data.area)
  useHydrateSelectedArea(data.prefectureCode)
  useHydrateSelectedPoplarRestaurantsArea(data.prefectureCode)
}

export type RootProps = { data: typeof loader }
